export enum AppointmentTypeCategoryEnum {
  Manual,
  IntegracaoPorto,
  PadraoLivance,
  PeriodoGarantido,
  OneLiv,
  Integracao,
}
